export default [
  {
    path: ":tipoOferta/dados-pessoais",
    name: "DadosPessoais",
    component: () =>
      import(
        /* webpackChunkName: "dados-pessoais" */ "@views/carrinho/dados-pessoais.vue"
      ),
  },
  {
    path: ":tipoOferta/:segmento/endereco",
    name: "Endereco",
    component: () =>
      import(/* webpackChunkName: "endereco" */ "@views/carrinho/endereco.vue"),
  },
  {
    path: ":tipoOferta/:segmento/fatura",
    name: "Fatura",
    component: () =>
      import(/* webpackChunkName: "endereco" */ "@views/carrinho/fatura.vue"),
  },
  {
    path: ":tipoOferta/:segmento/esqueci-cep",
    name: "EsqueciMeuCep",
    component: () =>
      import(
        /* webpackChunkName: "esqueci-cep" */ "@views/carrinho/esqueci-cep.vue"
      ),
  },
  {
    path: ":tipoOferta/:segmento/complemento",
    name: "ComplementarDados",
    component: () =>
      import(/* webpackChunkName: "complemento" */ "@views/complemento.vue"),
  },
  {
    path: ":tipoOferta/:segmento/token",
    name: "Autenticacao",
    component: () =>
      import(/* webpackChunkName: "token" */ "@views/carrinho/token.vue"),
  },
  {
    path: ":tipoOferta/:segmento/dependentes",
    name: "Dependentes",
    component: () =>
      import(
        /* webpackChunkName: "dependentes" */ "@views/carrinho/add-dependentes.vue"
      ),
  },
];
